import { FC } from 'react';

import Icon from 'molecules/Icon';

import { ComparisonTableRowField } from 'components/Tables/Comparison/config';

interface MobileComparisonRowProps extends ComparisonTableRowField {
  isPrismatic?: boolean;
}

const MobileComparisonRow: FC<MobileComparisonRowProps> = ({ isPrismatic, prismatic, competitor, rowHeading }) => {
  const cell = isPrismatic ? prismatic : competitor;
  const cellResult = cell?.cell;

  return (
    <li className="grid grid-cols-[1fr,64px] items-stretch overflow-hidden border-b border-b-white/10 py-4 pr-4 last-of-type:border-b-0 sm:pr-0">
      <div className="px-4">
        <span className="block text-md leading-snug text-white">{rowHeading}</span>
      </div>

      <div className="flex items-center justify-center px-3">
        {cellResult === 'check' && (
          <>
            <Icon icon="circle-check-1" size={17} className="text-primary-300" />
            <span className="sr-only">Yes</span>
          </>
        )}
        {cellResult === 'x' && (
          <>
            <Icon icon="x-mark" size={17} className="text-gray-600" />
            <span className="sr-only">No</span>
          </>
        )}
        {cellResult === 'text' && (
          <span className="whitespace-pre-line break-words text-center text-sm leading-snug text-gray-300">
            {cell?.text}
          </span>
        )}
      </div>
    </li>
  );
};

export default MobileComparisonRow;
